import { render, staticRenderFns } from "./DishCategory.vue?vue&type=template&id=5ac3dcd8&scoped=true"
import script from "./DishCategory.vue?vue&type=script&lang=js"
export * from "./DishCategory.vue?vue&type=script&lang=js"
import style0 from "./DishCategory.vue?vue&type=style&index=0&id=5ac3dcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3dcd8",
  null
  
)

export default component.exports